import { create } from 'zustand';
import { subscribeConnectIdentityInvalidation } from '../api/grpc/revitClient';
import { subscribeGrpcTargetChange } from '../api/grpc/grpcRuntime';
import { setUserHeaderSource } from '../api/grpc/transport';
import { createAuthStoreState } from './authStoreActions';
import { clearVerifiedTarget, invalidateFingerprint } from './authStoreFingerprint';
import type { AuthStore } from './authStoreTypes';
import { DEVICE_VERIFICATION_ERROR } from '../lib/machineFingerprint';

export const useAuthStore = create<AuthStore>((set, get) => createAuthStoreState(set, get));

subscribeGrpcTargetChange(() => {
  invalidateFingerprint();
  useAuthStore.setState({
    machineFingerprint: null,
    fingerprintLoading: false,
    fingerprintError: DEVICE_VERIFICATION_ERROR,
  });
});

subscribeConnectIdentityInvalidation(() => {
  if (useAuthStore.getState().machineFingerprint) {
    clearVerifiedTarget();
    useAuthStore.setState({ machineFingerprint: null, fingerprintError: DEVICE_VERIFICATION_ERROR });
  }
});

// Feed the gRPC transport's userHeadersInterceptor without transport importing
// this store (which would re-introduce the revitClient->transport->useAuthStore
// cycle). transport reads the current user lazily through this snapshot getter.
// Guarded: this is a load-time wiring side effect, and many tests partially
// jest.mock('.../transport') without setUserHeaderSource — the guard keeps the
// store module loadable under those mocks (real transport always provides it).
if (typeof setUserHeaderSource === 'function') {
  setUserHeaderSource(() => useAuthStore.getState().user);
}
